export default {
  NAME: 'name',
  CODE: 'code',
  RENDERING: 'rendering',
};
